import React from 'react'

export const Loader = () => {
  return (
    <div>
    <div className="page-loader">
        <img src='/img/loader.svg' alt="loader" />
    </div>
</div>
  )
}
